import React, { Component } from "react";
import { DialogActions, DialogTitle, Select, MenuItem, RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";
import { BlueOutlinedButton, BlueButton } from "js/react/components/UiComponents";
import { TEAM_USER_ROLES } from "common/constants";

export default class RemoveMemberFromOrgDialog extends Component {
    state = {
        transferTo: "self",
        newOwner: { email: "Select team member" }
    };

    get memberDisplayName() {
        const { member } = this.props;
        return member.displayName || member.email;
    }

    handleChange = event => {
        if (event.target.value === "self" || event.target.value === "other") {
            this.setState({ transferTo: event.target.value });
        }
    };

    render() {
        const { allMembers, member } = this.props;
        const { newOwner, transferTo } = this.state;
        const simplifiedMembers = allMembers.map(member => ({
            email: member.email,
            id: member.id,
            role: member.role
        }));
        const filteredMembers = simplifiedMembers.filter(member => member.email !== this.props.member.email);

        return (
            <BeautifulDialog PaperProps={{ style: { maxWidth: 650 } }}>
                <DialogTitle>Are you sure you want to remove {this.memberDisplayName} from the team?</DialogTitle>
                <DialogContent>
                    <span style={{ color: "black", letterSpacing: .5, fontSize: 14 }}>
                        Removing a member from your organization means they will no longer have access to shared team libraries. {
                            member.role !== TEAM_USER_ROLES.MEMBER && "Once they are removed, their Team Pro license will become available to assign to someone else."}
                    </span>
                    <div style={{ marginTop: 15, display: "flex", alignItems: "center" }}>

                        <RadioGroup
                            style={{ flexDirection: "inherit" }}
                            value={transferTo}
                            onChange={this.handleChange}
                        >
                            <FormControlLabel
                                value="self"
                                control={<Radio color="primary" />}
                                label={`Transfer ${this.memberDisplayName}'s presentations to their personal workspace.`}
                            />
                            <FormControlLabel
                                value="other"
                                control={<Radio color="primary" />}
                                label={`Transfer ${this.memberDisplayName}'s presentations to: `}
                            />
                            <Select
                                SelectDisplayProps={{ style: { textTransform: "unset" } }}
                                variant="outlined"
                                disableUnderline
                                onChange={event => {
                                    this.setState({ newOwner: filteredMembers.find(member => member.id === event.target.value) });
                                }}
                                value={newOwner.email}
                                renderValue={value => value}
                            >
                                {filteredMembers.map(member => (
                                    <MenuItem key={member.id} value={member.id}>
                                        {member.email}
                                    </MenuItem>
                                ))}
                            </Select>
                        </RadioGroup>
                    </div>

                </DialogContent>
                <DialogActions>
                    <BlueOutlinedButton
                        onClick={this.props.closeDialog}
                    >
                        Nevermind
                    </BlueOutlinedButton>
                    <BlueButton disabled={transferTo === "other" && !newOwner.id} onClick={() => {
                        const isTransferringOwner = transferTo === "other";
                        const type = newOwner.role === TEAM_USER_ROLES.MEMBER && member.role !== TEAM_USER_ROLES.MEMBER
                            ? "transfer_downgrade_presentations"
                            : "transfer_presentations";
                        this.props.onAccept(isTransferringOwner, member, newOwner, type);
                        this.props.closeDialog();
                    }}>
                        Remove member
                    </BlueButton>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
